module.exports = "/images/milestones-logo-color.svg?b343945965d932c9767ebb68d32be180";